module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO49CalculadoraDePatrimonioa.212e47b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO49CalculadoraDePatrimonioa.mp4
// module id = 775
// module chunks = 1